import React, { memo, useRef }     from 'react';
import PropTypes                   from 'prop-types';
import Translations                from '../../../utils/Translations';
import ModelHeatMapChart           from '../../ModelHeatmapChart/ModelHeatMapChart';
import withActorHeatMaps           from '../../HigherOrderComponents/ActorHeatMaps/withActorHeatMaps';
import {openVipPayTour}            from '../../ModelHeatmapChart/openVipPayTour';
import VipBadge                    from '../../Dailybonus/SubComponents/VipBadge';
import {getSeoHeadlineTranslation} from '../../../utils/TranslationHelper';
import Flux                        from '../../../flux/Flux';

/**
 * @param {number} duration
 * @returns {string}
 */
function formatAsUserDates(duration) {
	duration /= 1000;
	if (duration >= 3600 * 24) {
		const rounded     = Math.round(duration / 3600 / 24);
		const translation = rounded === 1 ? Translations.get('DateDay') : Translations.get('ActorProfileHeatMapDays');

		return ' ' + rounded + ' ' + translation;
	}
	if (duration >= 3600) {
		const rounded     = Math.round(duration / 3600);
		const translation = rounded === 1 ? Translations.get('Hour') : Translations.get('ActorProfileHeatMapHours');

		return ' ' + rounded + ' ' + translation;
	}

	const rounded     = Math.round(duration / 60);
	const translation = rounded === 1 ? Translations.get('Minute') : Translations.get('ActorProfileHeatMapMinutes');

	return ' ' + rounded + ' ' + translation;
}

/**
 * @param {boolean} actorIsOnline
 * @param {string} actorLastOnline
 * @param {string} actorName
 * @returns {*}
 */
function getIsOnlineMessage(actorIsOnline, actorLastOnline, actorName) {
	return actorIsOnline ? actorName + ' ' + Translations.get('NavbarActorStatusOnline')
		: Translations.get('ActorProfileHeatMapOnlineHoursAgo')
			.replace(':time', formatAsUserDates(new Date() - Date.parse(actorLastOnline)));
}

const ActorProfileHeatMap = memo((props) => {
	
	const {actorIsOnline, actorLastOnline, daysActivity, hoursToBeOnline, isLoggedIn, isOverview, restricted, memo, actorName} = props;

	const heatmapContainerRef = useRef(null);

	const textBody = restricted ? (
		<div className='actor-profile--heatmap_freetext h-mt-20'>
			<p className="h-text-normal h-mb-5 actor-profile--heatmap__text">{Translations.get('actor_profile.heatmap-subtext')}</p>
			<p className="h-text-light actor-profile--heatmap__text">{Translations.get(Flux.Browser.isSexole() ? 'actor_profile.heatmap-description--sexole' : 'actor_profile.heatmap-description')}</p>
			{isLoggedIn && <div className='become-vip'>
				<a className="btn -btn-color-gold h-text-transform-none h-text-normal" onClick={openVipPayTour}>
					{Translations.get('ActorProfileHeatMapBecomeVip')}
				</a>
			</div>}
		</div>
	) : (
		<div className='actor-profile--heatmap__online-text-container'>
			<p className="actor-profile--heatmap__online">
				<i className="icon -icon-round-time-line icon-centered-to-text"></i> {getIsOnlineMessage(actorIsOnline, actorLastOnline, actorName)}
			</p>
			{
				!actorIsOnline && hoursToBeOnline > 0 &&
				<p className="actor-profile--heatmap__text">{Translations.get('ActorProfileHeatMapProbablyOnline') + formatAsUserDates(hoursToBeOnline * 3600 * 1000)}</p>
			}
			<p className="actor-profile--heatmap__online">{memo}</p>
		</div>
	);

	return (
		<div ref={heatmapContainerRef} className={`actor-profile-block actor-profile--heatmap ${isOverview ? "-heatmap-overview" : ""}`} >
			<div className={`actor-profile--heatmap__text-container ${isOverview ? "-heatmap-overview" : ""}`}>
				<div className={`actor-profile--heatmap__title-container h-mb-10 ${!Flux.Guest.isVip() ? "h-mb-20" : ""}`}>
					<div className={`${isOverview ? "context-box__title" : "feed__headline h-over-ellipsis"}`}>{getSeoHeadlineTranslation('profile_overview_cam_h2')}</div>
					{!restricted && <VipBadge show={true} />}
				</div>
				{isOverview && textBody}
			</div>

			<ModelHeatMapChart 
				containerRef = {heatmapContainerRef}
				restricted	 = {restricted} 
				daysActivity = {daysActivity} 
				isMobile	 = {props.isMobile} 
				isOverview	 = {isOverview}
			/>
			{!isOverview && textBody}
		</div>
	);
});



ActorProfileHeatMap.defaultProps = {
	restricted: true,
	memo:       Translations.get('actor_profile.heatmap-description--vip'),
};

ActorProfileHeatMap.propTypes = {
	restricted:      PropTypes.bool,
	actorId:         PropTypes.number.isRequired,
	actorName:       PropTypes.string,
	actorIsOnline:   PropTypes.bool,
	actorLastOnline: PropTypes.string,
	daysActivity:    PropTypes.arrayOf(PropTypes.shape({
		date:     PropTypes.string,
		activity: PropTypes.arrayOf(PropTypes.shape({
			level: PropTypes.number,
			start: PropTypes.number,
			end:   PropTypes.number,
		})),
	})),
	hoursToBeOnline: PropTypes.number,
	isLoggedIn:      PropTypes.bool,
	isMobile:        PropTypes.bool,
	isOverview:      PropTypes.bool,
	memo:            PropTypes.string,
};

export default withActorHeatMaps(ActorProfileHeatMap);
